import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SparkMD5 from 'spark-md5';
import { FormGroup, Label } from 'reactstrap';
import entityComposition from '../classes/entityComposition';
import signatureHandling from './signatureHandling';
import Signature from './signature';

// must be defined outside of the component to avoid re-rendering loops
const defaultOnChange = () => {};
const defaultOnUpload = () => {};
const SignatureInput = _ref => {
  let _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$penColor = _ref.penColor,
    penColor = _ref$penColor === void 0 ? 'black' : _ref$penColor,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? defaultOnChange : _ref$onChange,
    _ref$onUpload = _ref.onUpload,
    onUpload = _ref$onUpload === void 0 ? defaultOnUpload : _ref$onUpload,
    _ref$handleSignatureD = _ref.handleSignatureData,
    handleSignatureData = _ref$handleSignatureD === void 0 ? null : _ref$handleSignatureD,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    notificationActions = _ref.notificationActions;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const handleChange = async signatureData => {
    if (!signatureData) {
      const change = handleSignatureData || onChange;
      change(null);
      return;
    }
    const signatureHash = SparkMD5.hash(signatureData);
    if (!handleSignatureData) {
      // Control save functionality internally
      setIsLoading(true);
      onUpload(true);
      try {
        const result = await signatureHandling.uploadSignature(signatureHash, signatureData);
        if (typeof result === 'string') {
          notificationActions.error({
            message: result
          });
          onChange(null);
        } else {
          onChange(result);
        }
      } catch (error) {
        notificationActions.error({
          message: 'There was a problem uploading the signature.'
        });
        onChange(null);
      } finally {
        setIsLoading(false);
        onUpload(false);
      }
    } else {
      // Expect parent component to handle saving correctly
      handleSignatureData(signatureData, signatureHash);
    }
  };
  return /*#__PURE__*/React.createElement(FormGroup, {
    className: "signature-form"
  }, label ? /*#__PURE__*/React.createElement(Label, null, label) : null, /*#__PURE__*/React.createElement(Signature, {
    className: className,
    penColor: penColor,
    loading: isLoading,
    disabled: disabled,
    onChange: handleChange
  }));
};
SignatureInput.propTypes = {
  className: PropTypes.string,
  penColor: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onUpload: PropTypes.func,
  handleSignatureData: PropTypes.func,
  disabled: PropTypes.bool,
  notificationActions: PropTypes.shape({
    error: PropTypes.func
  }).isRequired
};
export { SignatureInput as TestSignatureInput };
export default entityComposition(SignatureInput, [], {}, ['notification']);